define('app/sdc/absolute/url/sdc-absolute-url-factory',["$location"], function ($location) {
	"use strict";
	return sdcAbsoluteUrlFactory;
    //returns an absolute url for the input relative url which is treated as either relative to the current url if no leading slash on the input, or if the input has a leading slash, relative to the application root (i.e. where the login page would be).
    //The returned url has the full absolute protocol://domain[:port]/application/sitename/zzzz?querystring copying everything by zzz from the current $location.absUrl. If the url navigates up, it will include ../../ etc (even if using a leading slash as the input, will include sufficient ../ to reach the application root. additional ../ can be entered in the input to reach above application root, and can output noncannonical or non normalised urls, including urls which point above the domain root)
	function sdcAbsoluteUrlFactory(relativeUrl, _currentAbsoluteUrl) {
		switch (arguments.length) {
			case 1:
				_currentAbsoluteUrl = $location.absUrl();
				break;
		}
		if (/^\//.test(relativeUrl)) {
			relativeUrl = ($location.path().replace(/^\/$/, "").replace(/\/[^/]+/g, "/..") + relativeUrl).replace(/^\/+/, "");
		}
		var splitUrl = _currentAbsoluteUrl.split("?"),
			protocolHostAndPath = splitUrl[0],
			queryString = splitUrl.slice(1).join("?");
		return protocolHostAndPath + (relativeUrl && (/[\/]$/.test(protocolHostAndPath) ? "" : "/") + relativeUrl) + (queryString ? ("?" + queryString) : "");
	}
});
